(function($) {
  /**
   * Toggle all policy block on column layout
   * @since 2019-11-01
   */
  $(document).on('click', 'table .block-policy__title', function(event) {
		event.preventDefault();

		var
		$this = $(this),
		$parent = $this.parents('tr'),
		$anchor = $parent.find('.block-policy__title'),
		$collapse = $parent.find('.block-policy__content')

		if ($collapse.hasClass('collapsing'))
			return

		if ($collapse.hasClass('show')) {
			$anchor
				.addClass('collapsed')
				.attr('aria-expanded', false)
			$collapse.collapse('hide')
		} else {
			$anchor
				.removeClass('collapsed')
				.attr('aria-expanded', true)
			$collapse.collapse('show')
		}
	});
})(jQuery);